import React from 'react';
import {
  BuildingLibraryIcon,
  SparklesIcon,
  FlagIcon,
  Squares2X2Icon,
} from '@heroicons/react/24/solid';
import SharedNavbarBottom from 'shared_items/NavbarBottom';

// Rebuilt 2026-08-19 for the Core module redesign — was
// structure/definitions/goals/controls (frame + 4 empty tabs). Now:
// frameworks (reusable visual repository) + the three time horizons
// (purpose/strategy/tactical). settings moved out — reachable via the gear
// icon in NavbarTop, same pattern as Health.
const TABS = [
  { key: 'frameworks', label: 'Frameworks', Icon: BuildingLibraryIcon },
  { key: 'purpose', label: 'Purpose', Icon: SparklesIcon },
  { key: 'strategy', label: 'Strategy', Icon: FlagIcon },
  { key: 'tactical', label: 'Tactical', Icon: Squares2X2Icon },
];

const NavbarBottom = ({ activeTab, handleTabChange }) => (
  <SharedNavbarBottom
    tabs={TABS}
    activeTab={activeTab}
    onTabChange={handleTabChange}
    moduleKey="core"
  />
);

export default NavbarBottom;
